module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_03_770_280_ko-4afd6691e4879bd2ad0f915130d9f625.jpg";